import { Instagram } from "lucide-react";

export const Header = ({ profile }) => (
  <header data-testid="site-header" className="relative z-10 flex items-center justify-between px-6 md:px-12 lg:px-20 py-6 border-b border-[var(--line)]">
    <a href="/" data-testid="brand-logo" className="flex items-baseline gap-2">
      <span className="font-display text-2xl font-semibold tracking-tight">HostNode</span>
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ash)]">tech / news</span>
    </a>
    <a
      href={profile?.url || "https://www.instagram.com/hostnode.cloud/"}
      target="_blank"
      rel="noreferrer"
      data-testid="header-follow-link"
      className="group flex items-center gap-2 rounded-full border border-[var(--line)] px-4 py-2 text-sm transition-colors duration-300 hover:border-[var(--volt)] hover:text-[var(--volt)]"
    >
      <Instagram className="h-4 w-4" />
      <span className="hidden sm:inline">@{profile?.username || "hostnode.cloud"}</span>
    </a>
  </header>
);
